








import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game, NightAction } from '@/class/game'
import { MASTER_ROLE } from '@/class/const'
import { ROLE_MESSAGE } from '@/class/message'
import { RoleId, CauseOfDeath, Action, GameState } from '@/enum'

@Component
export default class NightActionResultMessages extends Vue {
  @Prop() game!: Game
  @Prop() nightAction!: NightAction
  @Prop() playerId!: string
  @Prop() state!: GameState.firstNight | GameState.night

  get messages () {
    const messages: string[] = []

    this.afterPlayers
      .filter(player => player.status.killed)
      .forEach(player => {
        messages.push(`${player.name}さんが死体で見つかりました。`)
    })

    const player = this.getPlayer(this.playerId)

    if (!player) {
      return messages
    }

    const targetName = this.getPlayer(player.selectedPlayerId)?.name || ''

    if (player.status.killed) {
      if (player.deathDetails?.cause === CauseOfDeath.eaten) {
        messages.push('あなたは蟹鍋にされて食べられてしまいました')
      } else {
        messages.push('あなたは殺害されました')
      }
    }

    if (player.deathDetails) {
      return messages
    }

    if (player.status.eatCrab) {
      messages.push('昨夜は蟹が美味しかったですね')
      return messages
    }

    if (player.status.tempted) {
      messages.push('女の子と楽しい一夜を過ごしていて何もできませんでした')
      return messages
    }

    if (player.status.stolen && MASTER_ROLE[player.roleId].weapon) {
      messages.push('昨夜は何故か得物が見当たらなかったため何もできませんでした')
      return messages
    }

    if (player.detonate) {
      const message = ROLE_MESSAGE[RoleId.bomber].action[Action.detonate].normal
      messages.push(message)
    } else if (player.useArmor) {
      const message = ROLE_MESSAGE[RoleId.survivor].action[Action.armor].normal
      messages.push(message)
    } else if (targetName) {
      const message = ROLE_MESSAGE[player.roleId].action[Action.targetSelect].normal
      messages.push(message.replace('{{targetName}}', targetName))
    } else {
      const message = ROLE_MESSAGE[player.roleId].action[Action.nothing].normal
      messages.push(message)
    }

    if (player.status.success === true) {
      const message = ROLE_MESSAGE[player.roleId].actionResult.success
      messages.push(message.replace('{{targetName}}', targetName))
    } else if (player.status.success === false) {
      const message = ROLE_MESSAGE[player.roleId].actionResult.failed
      messages.push(message.replace('{{targetName}}', targetName))
    }

    if (player.roleId === RoleId.mafia) {
      const message = this.getMafiaTargetMessage()
      const mafiaTargetName = this.getPlayer(this.nightAction.mafiaTargetId)?.name || ''
      messages.push(message.replace('{{targetName}}', mafiaTargetName))
    }

    return messages
  }

  getMafiaTargetMessage () {
    return this.nightAction.mafiaTargetId ? 'マフィアたちは{{targetName}}を襲撃した' : 'マフィアたちは誰も襲わなかった'
  }

  getPlayer(playerId: string) {
    return this.afterPlayers.find(p => p.id === playerId)
  }

  get afterPlayers() {
    return Object.values(this.afterPlayerOf).sort((a, b) => a.id > b.id ? 1 : -1)
  }

  get afterPlayerOf() {
    return this.nightAction.playLogs.length ? this.nightAction.playLogs[this.nightAction.playLogs.length - 1].afterPlayers : {}
  }
}
